import './time.css';
import {useLocation, useNavigate} from "react-router-dom";
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import styled, {css} from "styled-components";
import DayOff from "../img/DayOff.svg";
import TimeOff from "../img/TimeOff.svg";
import {useDispatch, useSelector} from "react-redux";
import {addressPush, nowPage, orderDate, PDaddressPush, PDorderAssignType, PDorderDate} from '../slices/counterSlice';
import {forwardRef, useEffect, useState, useRef} from "react";
import {getCoordinate, getPlaceSearch} from '../api/kakao';
import SetDatePicker from "react-datepicker";
import SearchIcon from '@mui/icons-material/Search';
import mixpanel from 'mixpanel-browser';
import {ko} from "date-fns/esm/locale";


const ContentFrame = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 80px;
  padding-top: 40px;
  @media (max-width: 1099px) {
    gap: 36px;
  }
`;

const SubContentFrame = styled.div`
  display: flex;
  flex-direction: column;
  gap: 30px;
  @media (max-width: 1099px) {
    gap: 10px;
  }
`;
const SubTitleFrame = styled.div`
  display: flex;
  justify-content: space-between;
`;
const SubTitle = styled.div`
  font-family: Gongim-Medium;
  font-size: 32px;
  @media (max-width: 1099px) {
    font-size: 18px;
  }
`;

const TableFrame = styled.div`
  display: flex;
  flex-direction: column;
  border-top: solid 2px #99a5ac;
  box-sizing: content-box;
`;

const TableRow = styled.div`
  width: 100%;
  border-bottom: solid 2px #ddd;
  box-sizing: content-box;
  padding: 28px 0;
  display: flex;
  justify-content: start;
  gap: 80px;
  @media (max-width: 767px) {
    border-bottom: none;
    flex-direction: column;
    padding: 0;
    gap: 0px;
  }
`;
const TableGroup = styled.div`
  width: 510px;
  display: flex;
  justify-content: start;
  align-items: center;
  @media (max-width: 1099px) {
    width: 100%;
  }
  @media (max-width: 767px) {
    padding: 28px 0;
    border-bottom: solid 2px #ddd;
  }
`;

const TableLeftTitle = styled.div`
  width: 150px;
  font-family: Gongim-Medium;
  font-size: 20px;
  text-align: left;
  color: #333;
  @media (max-width: 1099px) {
    width: 104px;

    font-size: 16px;
  }
`;

const CarSelect = styled.div`
  width: 260px;
  height: 40px;
  padding: 0 20px;
  border: 1px solid #707070;
  color: #999;
  font-family: Gongim-Medium;
  font-size: 16px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  @media (max-width: 1099px) {
    width: 100%;
    height: 36px;
    flex: 1;
    font-size: 14px;
    padding: 0 12px;
  }
`;

const CarImg = styled.img`
  width: 24px;
`;

const ButtonLine = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  gap: 20px;
  padding: 0 0 80px 0;
  @media (max-width: 1099px) {
    gap: 10px;
    padding: 36px 0;
  }
`;

const ButtonRed = styled.div`
  width: 230px;
  height: 50px;
  border-radius: 4px;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #eb3f3d;
  color: #fff;
  font-family: Gongim-Medium;
  font-size: 20px;
  cursor: pointer;
  ${(props) =>
    props.disable === true ?
      css`
      background-color: #999;
      color: #fff;
    ` :
      css`
      background-color: #eb3f3d;
      color: #fff;
    `
  }
  @media (max-width: 1099px) {
    flex: 1;
    height: 40px;
    font-size: 18px;
  }
`;

const ButtonBack = styled.div`
  width: 230px;
  height: 50px;
  border-radius: 4px;
  border: 1px solid #707070;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #fff;
  color: #707070;
  font-family: Gongim-Medium;
  font-size: 20px;
  cursor: pointer;
  @media (max-width: 1099px) {
    flex: 1;
    height: 40px;
    font-size: 18px;
  }
`;

const Text = styled.div`
  color: #000;
`;

const BackgroundBlack = styled.div`
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0;
  left: 0;
  z-index: -1;

`;

const PricePopup = styled.div`
  padding: 36px 20px;
  padding-bottom: 0;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  width: 480px;
  height: 615px;
  background: #FFFFFF;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  @media (max-width: 1099px) {
    width: 480px;
    height: 480px;
  }
  @media (max-width: 767px) {
    height: 100%;
    width: 100%;
  }
`

const PopupWrapper = styled.div`
  width: 100%;
  height: 480px;
  overflow-y: scroll;
  @media (max-width: 767px) {
    height: 100%;
    width: 100%;
  }
`;

const AddressInput = styled.input`
  width: 100%;
  height: 45px;
  margin: 20px 0;
  padding: 0 10px;
  border: 0;
  border-top: 1px solid #999;
  border-bottom: 1px solid #999;
  border-radius: 0;
  font-size: 15px;
  color: #999;
  online: none;
`

const AddressFrame = styled.div`
  width: 100%;
  height: auto;
  display: flex;
  //padding: 10px 0;
  padding: 8px;
  justify-content: space-between;
  border-bottom: 1px solid #E1E3E8;
`;
export default function Content02() {
  const nowData = new Date();

  const nowHour = nowData.getHours();
  const nowMin = nowData.getMinutes();

  //시간
  const [PtimeSelect, setPTimeSelect] = useState(false);
  const [DtimeSelect, setDTimeSelect] = useState(false);

  const [PHH, setPHH] = useState(nowMin > 0 ? nowHour + 2 : nowHour + 1);
  const [PMM, setPMM] = useState('00');

  const [DHH, setDHH] = useState(nowMin > 0 ? nowHour + 2 : nowHour + 1);
  const [DMM, setDMM] = useState('00');


  //주소
  const [sendAddrInput, setSendAddrInput] = useState('');
  const [endAddrInput, setEndAddrInput] = useState('');


  // 주소(도로명)
  const [sendAddrResult, setSendAddrResult] = useState([]);
  const [endAddrResult, setEndAddrResult] = useState([]);

  // 주소(건물명, 장소명)
  const [sendPAddrResult, setSendPAddrResult] = useState([]);
  const [endPAddrResult, setEndPAddrResult] = useState([]);


  const [addressAssignType, setAddressAssignType] = useState('');


  // 픽업
  const [pickupSendAddr, setPickupSendAddr] = useState('');
  const [pickupSendAddrDetail, setPickupSendAddrDetail] = useState('');
  const [pickUpEndAddr, setPickupEndAddr] = useState('');
  const [pickUpEndAddrDetail, setPickupEndAddrDetail] = useState('');

  const [pickupDate, setPickupDate] = useState(new Date());
  const [pickupTime, setPickupTime] = useState('');

  // 딜리버리
  const [deliSendAddr, setDeliSendAddr] = useState('');
  const [deliSendAddrDetail, setDeliSendAddrDetail] = useState('');
  const [deliEndAddr, setDeliEndAddr] = useState('');
  const [deliEndAddrDetail, setDeliEndAddrDetail] = useState('');

  const [deliDate, setDeliDate] = useState(new Date());
  const [deliTime, setDeliTime] = useState('');

  const [btnDisable, setbtnDisable] = useState(true);

  const [openSenderAddrPostcode, setOpenSenderAddrPostcode] = useState(false);
  const [openEndAddrPostcode, setOpenEndAddrPostcode] = useState(false);


  const [sendAddrDialogOpen, setSendAddrDialogOpen] = useState(false);
  const [endAddrDialogOpen, setEndAddrDialogOpen] = useState(false);



  const hour = [
    '00',
    '01',
    '02',
    '03',
    '04',
    '05',
    '06',
    '07',
    '08',
    '09',
    '10',
    '11',
    '12',
    '13',
    '14',
    '15',
    '16',
    '17',
    '18',
    '19',
    '20',
    '21',
    '22',
    '23',
  ]

  const mm = [
      '00',
      '10',
      '20',
      '30',
      '40',
      '50'
  ]

  const scrollRef = useRef();



  const navigate = useNavigate();
  let data = useSelector((state) => state.counter.data.data);
  let PDdata = useSelector((state) => state.counter.data.PDdata);
  let fin = useSelector((state) => state.counter.data.complate);
  let PD = useSelector((state) => state.counter.data.assignType);
  const dispatch = useDispatch();
  const path = useLocation();


  if (fin === true) {
    window.location.replace('/fin')
  }

  if (data.user.phoneNo === '') {
    window.location.replace('/')
  }

  useEffect(() => {
    // if (pickupSendAddr !== '' && pickUpEndAddr !== '' && pickupDate !== '' && pickupTime !== '' || deliSendAddr !== '' && deliEndAddr !== '' && deliDate !== '' && deliTime !== '') {
    //   setbtnDisable(false)
    // }
    if (data.assignType === 1) {
      if (pickupSendAddr !== '' && pickUpEndAddr !== '' && pickupDate !== '' && pickupTime !== '') {
        setbtnDisable(false);
      }
    } else if (data.assignType === 3) {
      if (deliSendAddr !== '' && deliEndAddr !== '' && deliDate !== '' && deliTime !== '') {
        setbtnDisable(false);
      }
    } else if (data.assignType === 2) {
      if (pickupSendAddr !== '' && pickUpEndAddr !== '' && pickupDate !== '' && pickupTime !== '' & deliSendAddr !== '' && deliEndAddr !== '' && deliDate !== '' && deliTime !== '') {
        setbtnDisable(false);
      }
    }
  })

  useEffect(() => {
    if (DHH !== '' && DMM !== '') {
      setDTimeSelect(false)
      setDeliTime(`${DHH}:${DMM}:00`);
    }
    if (PHH !== '' && PMM !== '') {
      setPTimeSelect(false)
      setPickupTime(`${DHH}:${DMM}:00`);
    }
  }, [DHH, DMM, PHH, PMM])
  dispatch(nowPage(path.pathname));



  const nextPage = async () => {
    if (btnDisable === true) {
      return;
    }

    // const changePickupformet = pickupDate.toISOString().split('T')[0];
    // const changeDeliformet = deliDate.toISOString().split('T')[0];

    // setPickupDate(changePickupformet);
    // setDeliDate(changeDeliformet);

    // setPickupTime(`${PHH}:${PMM}:00`);
    // setDeliTime(`${DHH}:${DMM}:00`);

    let sendParams = {
      query: data.assignType === 1 ? pickupSendAddr : deliSendAddr,
      page: 10,
      size: 10
    }
    let sendLat = '';
    let sendLon = '';
    await getCoordinate(sendParams).then(res => {
      if(res.data.meta.total_count > 0) {
        sendLat = res.data.documents[0].y
        sendLon = res.data.documents[0].x
      } else {
        sendLat = '';
        sendLon = '';
      }
    })
    if(sendLat === '' && sendLon === '') {
      //주소가 없을경우 장소로 검색
      await getPlaceSearch(sendParams).then(res => {
        sendLat = res.data.documents[0].y
        sendLon = res.data.documents[0].x
      })
    }

    let endParams = {
      query: data.assignType === 1 ? pickUpEndAddr : deliEndAddr,
      page: 10,
      size: 10
    }
    let endLat = '';
    let endLon = '';
    await getCoordinate(endParams).then(res => {
      if(res.data.meta.total_count > 0) {
        endLat = res.data.documents[0].y
        endLon = res.data.documents[0].x
      } else {
        endLat = '';
        endLon = '';
      }
    })
    if(endLat === '' && endLon === '') {
      //주소가 없을경우 장소로 검색
      await getPlaceSearch(endParams).then(res => {
        endLat = res.data.documents[0].y
        endLon = res.data.documents[0].x
      })
    }

    const address = {
      sendAddr: data.assignType === 1 ? pickupSendAddr : deliSendAddr,
      sendAddrDetail: data.assignType === 1 ? pickupSendAddrDetail : deliSendAddrDetail,
      sendLat: sendLat,
      sendLon: sendLon,
      endAddr: data.assignType === 1 ? pickUpEndAddr : deliEndAddr,
      endAddrDetail: data.assignType === 1 ? pickUpEndAddrDetail : deliEndAddrDetail,
      endLat: endLat,
      endLon: endLon
    }
    dispatch(addressPush(address))
    if (data.assignType === 1) {
      dispatch(orderDate(`${pickupDate.toISOString().split('T')[0]} ${PHH}:${PMM}:00`))
    } else if (data.assignType === 3) {
      dispatch(orderDate(`${deliDate.toISOString().split('T')[0]} ${DHH}:${DMM}:00`))
    }
    mixpanel.track("주소, 날짜, 시간 입력 후 확인버튼을 클릭");
    console.log(address);
    navigate('/price')

    // dispatch({type:"PRICE"})
    // if(data.routes[0].lat !== '' && data.routes[0].lon !== '' && data.routes[1].lon !== '' && data.routes[1].lon !== '') {
    // }
  }


  const pickupAndDeliNextPage = async () => {
    if (btnDisable === true) {
      return;
    }
    // const changePickupformet = pickupDate.toISOString().split('T')[0];
    // const changeDeliformet = deliDate.toISOString().split('T')[0];


    // setPickupDate(changePickupformet);
    // setDeliDate(changeDeliformet);

    // setPickupTime(`${PHH}:${PMM}:00`);
    // setDeliTime(`${DHH}:${DMM}:00`);


    // --------------- 픽업 --------------------

    let PsendParams = {
      query: pickupSendAddr,
      page: 1,
      size: 1
    }
    let PsendLat = '';
    let PsendLon = '';
    await getCoordinate(PsendParams).then(res => {
      if (res.data.meta.total_count > 0) {
        PsendLat = res.data.documents[0].y
        PsendLon = res.data.documents[0].x
      } else {
        PsendLat = "";
        PsendLon = "";
      }
    })
    let PendParams = {
      query: pickUpEndAddr,
      page: 1,
      size: 1
    }
    let PendLat = '';
    let PendLon = '';
    await getCoordinate(PendParams).then(res => {
      if (res.data.meta.total_count > 0) {
        PendLat = res.data.documents[0].y
        PendLon = res.data.documents[0].x
      } else {
        PendLat = "";
        PendLon = "";
      }
    })
    const Paddress = {
      sendAddr: pickupSendAddr,
      sendAddrDetail: pickupSendAddrDetail,
      sendLat: PsendLat,
      sendLon: PsendLon,
      endAddr: pickUpEndAddr,
      endAddrDetail: pickUpEndAddrDetail,
      endLat: PendLat,
      endLon: PendLon
    }
    dispatch(addressPush(Paddress))
    dispatch(orderDate(`${pickupDate.toISOString().split('T')[0]} ${PHH}:${PMM}:00`))

    // --------------- 딜리버리 --------------------


    let DsendParams = {
      query: deliSendAddr,
      page: 1,
      size: 1
    }
    let DsendLat = '';
    let DsendLon = '';
    await getCoordinate(DsendParams).then(res => {
      if (res.data.meta.total_count > 0) {
        DsendLat = res.data.documents[0].y
        DsendLon = res.data.documents[0].x
      } else {
        DsendLat = "";
        DsendLon = "";
      }
    })
    let DendParams = {
      query: deliEndAddr,
      page: 1,
      size: 1
    }
    let DendLat = '';
    let DendLon = '';
    await getCoordinate(DendParams).then(res => {
      if (res.data.meta.total_count > 0) {
        DendLat = res.data.documents[0].y
        DendLon = res.data.documents[0].x
      } else {
        DendLat = "";
        DendLon = "";
      }
    })
    const Daddress = {
      sendAddr: deliSendAddr,
      sendAddrDetail: deliSendAddrDetail,
      sendLat: DsendLat,
      sendLon: DsendLon,
      endAddr: deliEndAddr,
      endAddrDetail: deliEndAddrDetail,
      endLat: DendLat,
      endLon: DendLon
    }

    dispatch(PDaddressPush(Daddress))
    dispatch(PDorderDate(`${deliDate.toISOString().split('T')[0]} ${DHH}:${DMM}:00`))

    dispatch(PDorderAssignType({ pickAndDeli: 2, pickup: 1, deli: 3 }))
    mixpanel.track("주소, 날짜, 시간 입력 후 확인버튼을 클릭");
    navigate('/price')
  }

  //픽업 날짜 변경 함수
  const pickupDateChange = (date) => {
    const nowYear = Number(nowData.toISOString().split("T")[0].split("-")[0]);
    const changeYear = Number(date.toISOString().split("T")[0].split("-")[0]);

    const nowMonth = Number(nowData.toISOString().split("T")[0].split("-")[1]);
    const changeMonth = Number(date.toISOString().split("T")[0].split("-")[1]);

    const nowDay = Number(nowData.toISOString().split("T")[0].split("-")[2]);
    const changeDay = Number(date.toISOString().split("T")[0].split("-")[2]);

    if((nowYear > changeYear && nowMonth > changeMonth && nowDay > changeDay) || (nowYear >= changeYear && nowMonth > changeMonth) || (nowYear === changeYear && nowMonth === changeMonth && nowDay > changeDay) || nowYear > changeYear) {
      alert("지난 날짜는 예약할 수 없습니다.");
      return ;
    }
    setPickupDate(date);
    setPHH(nowMin > 0 ? nowHour + 2 : nowHour + 1);
    setPMM("00");
  }

  //딜리버리 날짜 변경 함수
  const deliDateChange = (date) => {
    const nowYear = Number(nowData.toISOString().split("T")[0].split("-")[0]);
    const changeYear = Number(date.toISOString().split("T")[0].split("-")[0]);

    const nowMonth = Number(nowData.toISOString().split("T")[0].split("-")[1]);
    const changeMonth = Number(date.toISOString().split("T")[0].split("-")[1]);

    const nowDay = Number(nowData.toISOString().split("T")[0].split("-")[2]);
    const changeDay = Number(date.toISOString().split("T")[0].split("-")[2]);

    if((nowYear > changeYear && nowMonth > changeMonth && nowDay > changeDay) || (nowYear >= changeYear && nowMonth > changeMonth) || (nowYear === changeYear && nowMonth === changeMonth && nowDay > changeDay) || nowYear > changeYear) {
      alert("지난 날짜는 예약할 수 없습니다.");
      return ;
    }
    setDeliDate(date);
    setDHH(nowMin > 0 ? nowHour + 2 : nowHour + 1);
    setDMM("00");
  }



  /*
    1. 픽업 출발지, 딜리버리 출발지 구분 필요 (변수명 : addressAssignType   사용할내용 : 픽업: P, 딜리버리: D)
    2. 픽업 출빌지, 딜리버리 출발지 인풋 클릭시 해당 변수에 값을 넣어줌
    3. 주소 팝업창은 공통으로 사용하지만 주소 클릭시 픽업에 넣을지 딜리버리에 넣을지 구분을 해줌
  */

  useEffect(() => {
    sendAddressSearch()
    setSendAddrInput(sendAddrInput)
    sendAddressSearch()
  }, [sendAddrInput])
  useEffect(() => {
    setEndAddrInput(endAddrInput)
    endAddressSearch()
    endAddressSearch()
  }, [endAddrInput])



  // 출발지 검색 엔진
  const sendAddressSearch = (e) => {
    let params = {
      query: sendAddrInput,
      analyze_type: 'similar',
      page: 1,
      size: 30,
    }
    if (sendAddrInput !== '') {
      getCoordinate(params).then(res => {
        let response = res.data.documents;
        if (response.length !== 0) {
          // console.log(response)
          setSendAddrResult(response);
          sendPAddrSearch(sendAddrInput);
        } else {
          setSendAddrResult([]);
          sendPAddrSearch(sendAddrInput);
        }
      }).catch(err => {
        console.log(err);
      })
    }
  }

  //출발지 장소 검색 엔진
  const sendPAddrSearch = (e) => {
    let params = {
      query: sendAddrInput,
      size: 10,
    }
    getPlaceSearch(params).then(res => {
      let response = res.data.documents;
      setSendPAddrResult(response);
    }).catch(err => {
      console.log(err);
    })
  }


  //출발지 선택시 작동되는 함수
  const sendAddresClick = (address) => {
    setSendAddrInput("");
    if (addressAssignType === "P") {
      if(data.assignType === 2) { // 픽업&딜리버리를 진행하엿을때 픽업 주소 반대로 딜리버리에 자동으로 입력된다
        setDeliEndAddr(address.address_name);
        setPickupSendAddr(address.address_name);
        if (address.road_address === null) {
          setPickupSendAddrDetail("");
          setDeliEndAddrDetail("");
        } else {
          setPickupSendAddrDetail(address.road_address.building_name);
          setDeliEndAddrDetail(address.road_address.building_name);
        }
      } else {
        setPickupSendAddr(address.address_name);
        if (address.road_address === null) {
          setPickupSendAddrDetail("")
        } else {
          setPickupSendAddrDetail(address.road_address.building_name)
        }
      }
    } else if (addressAssignType === "D") {
      setDeliSendAddr(address.address_name);
      if (address.road_address === null) {
        setDeliSendAddrDetail("")
      } else {
        setDeliSendAddrDetail(address.road_address.building_name)
      }
    }
    setSendAddrDialogOpen(false);
  }


  //출발리 장소 선택시 작동되는 함수
  const sendPAddresClick = (address) => {
    setSendAddrInput("");
    if (addressAssignType === "P") {
      if(data.assignType === 2) { // 픽업&딜리버리를 진행하엿을때 픽업 주소 반대로 딜리버리에 자동으로 입력된다
        setPickupSendAddr(address.address_name);
        setDeliEndAddr(address.address_name);
        setPickupSendAddrDetail(address.place_name);
        setDeliEndAddrDetail(address.place_name);
      } else {
        setPickupSendAddr(address.address_name);
        setPickupSendAddrDetail(address.place_name);
      }
    } else if (addressAssignType === "D") {
      setDeliSendAddr(address.address_name);
      setDeliSendAddrDetail(address.place_name);
    }
    setSendAddrDialogOpen(false);
  }



  // 도착지 검색 엔진
  const endAddressSearch = (e) => {
    let params = {
      query: endAddrInput,
      analyze_type: 'similar',
      page: 1,
      size: 30,
    }
    if (endAddrInput !== '') {
      getCoordinate(params).then(res => {
        let response = res.data.documents;
        if (response.length !== 0) {
          setEndAddrResult(response);
          endPAddressSearch(endAddrInput);
        } else {
          setEndAddrResult([]);
          endPAddressSearch(endAddrInput);
        }
      }).catch(err => {
        console.log(err);
      })
    }
  }

  // 도착지 장소 검색 엔진
  const endPAddressSearch = () => {
    let params = {
      query: endAddrInput,
      size: 10,
    }
    getPlaceSearch(params).then(res => {
      let response = res.data.documents;
      setEndPAddrResult(response);
    }).catch(err => {
      console.log(err);
    })
  }

  //도착지 선택시 작동되는 함수
  const endAddresClick = (address) => {
    if (addressAssignType === "P") {
      if (data.assignType === 2) { // 픽업&딜리버리를 진행하엿을때 픽업 주소 반대로 딜리버리에 자동으로 입력된다
        setPickupEndAddr(address.address_name);
        setDeliSendAddr(address.address_name);
        if (address.road_address === null) {
          setPickupEndAddrDetail("")
          setDeliSendAddrDetail("")
        } else {
          setPickupEndAddrDetail(address.road_address.building_name)
          setDeliSendAddrDetail(address.road_address.building_name)
        }
      } else {
        setPickupEndAddr(address.address_name);
        if (address.road_address === null) {
          setPickupEndAddrDetail("")
        } else {
          setPickupEndAddrDetail(address.road_address.building_name)
        }
      }
    } else if (addressAssignType === "D") {
      setDeliEndAddr(address.address_name);
      if (address.road_address === null) {
        setDeliEndAddrDetail("")
      } else {
        setDeliEndAddrDetail(address.road_address.building_name)
      }
    }
    setEndAddrDialogOpen(false);
  }

  //도착지 장소 선택시 작동되는 함수
  const endPAddresClick = (address) => {
    setSendAddrInput("");
    if (addressAssignType === "P") {
      if(data.assignType === 2) {// 픽업&딜리버리를 진행하엿을때 픽업 주소 반대로 딜리버리에 자동으로 입력된다
        setPickupEndAddr(address.address_name);
        setDeliSendAddr(address.address_name);
        setPickupEndAddrDetail(address.place_name);
        setDeliSendAddrDetail(address.place_name);
      } else {
        setPickupEndAddr(address.address_name);
        setPickupEndAddrDetail(address.place_name);
      }
    } else if (addressAssignType === "D") {
      setDeliEndAddr(address.address_name);
      setDeliEndAddrDetail(address.place_name);
    }
    setEndAddrDialogOpen(false);
  }



  const sendDialogClose = () => {
    setSendAddrDialogOpen(false);
    setSendAddrResult([]);
    setSendPAddrResult([]);
  };
  const endDialogClose = () => {
    setEndAddrDialogOpen(false);
    setEndAddrResult([]);
    setEndPAddrResult([]);
  };

  const changeTime = (type, time) => {
    const date = new Date();
    const nowDate = date.toISOString().split("T")[0];
    const nowHour = date.getHours();
    const nowMin = date.getMinutes();

    const Pdate = pickupDate.toISOString().split("T")[0];
    const Ddate = deliDate.toISOString().split("T")[0];
    const PDdate = deliDate.toISOString().split("T")[0];

    if(type === 'PHH' && nowDate === Pdate) {
      if(Number(nowHour) === Number(time) || Number(nowHour + 1) === Number(time)) {
        alert("출발 시간까지 시간이 촉박한 경우 배차가 지연될 수 있습니다.\n원활한 서비스 이용을 위해 1시간 이상 여유를 두시는 걸 추천드립니다.");
        setPHH(time);
      } else if (Number(nowHour) > Number(time)) {
        alert("지난시간은 예약이 불가능 합니다.")
      } else {
        setPHH(time);
      }
    } else if (type === 'PHH') {
      setPHH(time);
    } else if (type === 'PMM') {
      setPMM(time);
    }

    if(type === 'DHH' && nowDate === Ddate) {
      if(Number(nowHour) === Number(time) || Number(nowHour + 1) === Number(time)) {
        alert("출발 시간까지 시간이 촉박한 경우 배차가 지연될 수 있습니다.\n원활한 서비스 이용을 위해 1시간 이상 여유를 두시는 걸 추천드립니다.");
        setDHH(time)
      } else if (Number(nowHour) > Number(time)) {
        alert("지난시간은 예약이 불가능 합니다.")
      } else {
        setDHH(time);
      }
    } else if (type === 'DHH') {
      setDHH(time);
    } else if (type === 'DMM') {
      setDMM(time);
    }
  }


  const timePSelect = () => {
    setPTimeSelect(!PtimeSelect);
    // setPHH('');
    // setPMM('');
    // setPickupTime('');
  }

  const timeDSelect = () => {
    setDTimeSelect(!DtimeSelect);
    // setDHH('');
    // setDMM('');
    // setDeliTime('');
  }
  const CustomDeliveryInput = forwardRef(({ value, onClick }, ref) => (
      <CarSelect onClick={onClick}>
        <span style={{ width: "100%", textAlign: "left" }} onClick={onClick} ref={ref}>{value}</span>
        <CarImg src={DayOff} />
      </CarSelect>

  ));

  const CustomPickupInput = forwardRef(({ value, onClick }, ref) => (
      <CarSelect onClick={onClick}>
        <span style={{ width: "100%", textAlign: "left" }} onClick={onClick} ref={ref}>{value}</span>
        <CarImg src={DayOff} />
      </CarSelect>
  ));


  return (
      <ContentFrame>
        {
            (data.assignType === 1 || data.assignType === 2 || PD === 2) &&
            <SubContentFrame>
              <SubTitleFrame>
                <SubTitle>차량 가져오기 (픽업)</SubTitle>
              </SubTitleFrame>
              <TableFrame>
                <TableRow>
                  <TableGroup>
                    <TableLeftTitle>출발</TableLeftTitle>
                    <CarSelect onClick={() => {
                      setAddressAssignType("P");
                      setSendAddrResult([]);
                      setSendPAddrResult([]);
                      setSendAddrDialogOpen(true);
                      setOpenSenderAddrPostcode(true);
                    }}>
                      {pickupSendAddr === '' ?
                          '차량 출발지 주소를 입력하세요.'
                          : <Text>{pickupSendAddr}</Text>
                      }
                    </CarSelect>
                  </TableGroup>
                  <TableGroup>
                    <TableLeftTitle>도착</TableLeftTitle>
                    <CarSelect onClick={() => {
                      setAddressAssignType("P");
                      setEndAddrResult([]);
                      setEndPAddrResult([]);
                      setEndAddrDialogOpen(true);
                      setOpenEndAddrPostcode(true);
                    }}>
                      {pickUpEndAddr === '' ?
                          '차량 도착지 주소를 입력하세요.'
                          : <Text>{pickUpEndAddr}</Text>
                      }
                    </CarSelect>
                  </TableGroup>
                </TableRow>
                <TableRow>
                  <TableGroup>
                    <TableLeftTitle>픽업 일자</TableLeftTitle>

                    <SetDatePicker
                        locale={ko}
                        style={{ width: "0px" }}
                        dateFormat='yyyy년MM월dd일'
                        selected={pickupDate}
                        onChange={(date) => {pickupDateChange(date)}}
                        customInput={<CustomPickupInput />}
                    />

                  </TableGroup>
                  <TableGroup style={{ position: "relative" }}>
                    <TableLeftTitle>픽업 시간</TableLeftTitle>
                    <CarSelect onClick={() => { timePSelect() }}>
                      {PMM === '' && PHH === '' ?
                          '예약시간을 선택하세요.' :
                          <span>{PHH}:{PMM}</span>
                      }
                      <CarImg src={TimeOff} />
                    </CarSelect>
                    {PtimeSelect &&
                        <div className="timeWrapper">
                          <div className="hour">
                            <div>
                              {
                                hour.map((hour, index) =>
                                    <div key={index} className='hourDetail' onClick={() => {
                                      changeTime('PHH', hour);
                                    }}>{hour}</div>
                                )
                              }
                            </div>
                          </div>
                          <div className='hour'>
                            <div>
                              {
                                mm.map((mm, index) =>
                                    <div key={index} className='hourDetail' onClick={() => {
                                      changeTime('PMM', mm);
                                      // setPMM(mm);
                                    }}>{mm}</div>
                                )
                              }
                            </div>
                          </div>
                        </div>
                    }
                  </TableGroup>
                </TableRow>
              </TableFrame>
            </SubContentFrame>
        }
        {
            (data.assignType === 3 || data.assignType === 2 || PD === 2) &&
            <SubContentFrame>
              <SubTitleFrame>
                <SubTitle>차량 보내기 (딜리버리)</SubTitle>
              </SubTitleFrame>
              <TableFrame>
                <TableRow>
                  <TableGroup>
                    <TableLeftTitle>출발</TableLeftTitle>
                    <CarSelect onClick={() => {
                      setAddressAssignType("D");
                      setSendAddrResult([]);
                      setSendPAddrResult([]);
                      setSendAddrDialogOpen(true);
                      setOpenSenderAddrPostcode(true);
                    }}>
                      {deliSendAddr === '' ?
                          '차량 출발지 주소를 입력하세요.'
                          : <Text>{deliSendAddr}</Text>
                      }
                    </CarSelect>
                  </TableGroup>
                  <TableGroup>
                    <TableLeftTitle>도착</TableLeftTitle>
                    <CarSelect onClick={() => {
                      setAddressAssignType("D");
                      setEndAddrResult([]);
                      setEndPAddrResult([]);
                      setEndAddrDialogOpen(true);
                      setOpenEndAddrPostcode(true);
                    }}>
                      {deliEndAddr === '' ?
                          '차량 도착지 주소를 입력하세요.'
                          : <Text>{deliEndAddr}</Text>
                      }
                    </CarSelect>
                  </TableGroup>
                </TableRow>
                <TableRow>
                  <TableGroup>
                    <TableLeftTitle>딜리버리 일자</TableLeftTitle>
                    <SetDatePicker
                        locale={ko}
                        style={{ width: "0px" }}
                        dateFormat='yyyy년MM월dd일'
                        selected={deliDate}
                        onChange={(date) => {deliDateChange(date)}}
                        customInput={<CustomDeliveryInput />}
                    />

                  </TableGroup>
                  <TableGroup style={{ position: "relative" }}>
                    <TableLeftTitle>딜리버리 시간</TableLeftTitle>
                    <CarSelect onClick={() => { timeDSelect() }}>
                      {DMM === '' && DHH === '' ?
                          '예약시간을 선택하세요.' :
                          <span>{DHH}:{DMM}</span>
                      }
                      <CarImg src={TimeOff} />
                    </CarSelect>
                    {DtimeSelect &&
                        <div className="timeWrapper">
                          <div className="hour">
                            <div>
                              {
                                hour.map((hour, index) =>
                                    <div key={index} className='hourDetail' onClick={() => {
                                      changeTime('DHH', hour);
                                      // setDHH(hour);
                                    }}>{hour}</div>
                                )
                              }
                            </div>
                          </div>
                          <div className='hour'>
                            <div>
                              {
                                mm.map((mm, index) =>
                                    <div key={index} className='hourDetail' onClick={() => {
                                      changeTime('DMM', mm)
                                      // setDMM(mm);
                                    }}>{mm}</div>
                                )
                              }
                            </div>
                          </div>
                        </div>
                    }
                  </TableGroup>

                </TableRow>
              </TableFrame>
            </SubContentFrame>
        }
        {openSenderAddrPostcode &&
            <Dialog
                open={sendAddrDialogOpen}
                onClose={sendDialogClose}
            >
              <DialogContent style={{ width: "480px", height: "615px" }}>
                <PricePopup>
                  <SubTitle style={{ fontSize: "22px" }}>출발지 검색</SubTitle>
                  <AddressInput placeholder='주소를 검색하세요' autoFocus onInput={(e) => { setSendAddrInput(e.target.value + " ") }} /><SearchIcon style={{ position: "absolute", top: "15%", right: "4%", fontSize: "30px" }} />
                  <PopupWrapper>
                    {(sendPAddrResult.length === 0 || sendAddrResult.length !== 0) &&
                        <>
                          {sendAddrResult.length === 0 ?
                              <AddressSubText style={{ width: '100%', marginTop: '200px', textAlign: 'center', fontSize: '14px' }}>출발지를 검색해주세요</AddressSubText> :
                              sendAddrResult.map((context) =>
                                  <AddressFrame key={context.id} style={{ cursor: "pointer" }} onClick={() => { sendAddresClick(context) }}>
                                    <div>
                                      {context.road_address === null || context.road_address.building_name === "" ?
                                          <AddressMainText>{context.address_name}</AddressMainText> :
                                          <AddressMainText>{context.road_address.building_name}</AddressMainText>
                                      }
                                      <AddressSubText>{context.address_name}</AddressSubText>
                                    </div>
                                    <div>
                                      <AddressSubText style={{ marginTop: '20px' }}>{context.category_group_name}</AddressSubText>
                                    </div>
                                  </AddressFrame>
                              )
                          }
                        </>
                    }
                    {(sendPAddrResult.length !== 0 || sendAddrResult.length === 0) &&
                        <>
                          {sendPAddrResult.map((context) =>
                              <AddressFrame key={context.id} style={{ cursor: "pointer" }} onClick={() => { sendPAddresClick(context) }}>
                                <div>
                                  <AddressMainText>{context.place_name}</AddressMainText>
                                  <AddressSubText>{context.road_address_name}</AddressSubText>
                                </div>
                                <div>
                                  <AddressSubText style={{ marginTop: '20px' }}>{context.category_group_name}</AddressSubText>
                                </div>
                              </AddressFrame>
                          )}
                        </>
                    }
                  </PopupWrapper>
                </PricePopup>
              </DialogContent>
            </Dialog>
        }
        {openEndAddrPostcode &&
            <Dialog
                open={endAddrDialogOpen}
                onClose={endDialogClose}
            >
              <DialogContent style={{ width: "480px", height: "615px" }}>
                <PricePopup>
                  <SubTitle style={{ fontSize: "22px" }}>도착지 검색</SubTitle>
                  <AddressInput placeholder='주소를 검색하세요' autoFocus onChange={(e) => { setEndAddrInput(e.target.value + " ") }} /><SearchIcon style={{ position: "absolute", top: "15%", right: "4%", fontSize: "30px" }} />
                  <PopupWrapper>
                    {(endPAddrResult.length === 0 || endAddrResult.length !== 0) &&
                        <>
                          {endAddrResult.length === 0 ?
                              <AddressSubText style={{ width: '100%', marginTop: '200px', textAlign: 'center', fontSize: '14px' }}>도착지를 검색해주세요</AddressSubText> :
                              endAddrResult.map((context) =>
                                  <AddressFrame key={context.id} style={{ cursor: "pointer" }} onClick={() => { endAddresClick(context) }}>
                                    <div>
                                      {context.road_address === null || context.road_address.building_name === "" ?
                                          <AddressMainText>{context.address_name}</AddressMainText> :
                                          <AddressMainText>{context.road_address.building_name}</AddressMainText>
                                      }
                                      <AddressSubText>{context.address_name}</AddressSubText>
                                    </div>
                                    <div>
                                      {/* <AddressSubText style={{ marginTop: '20px' }}>{context.address_type}</AddressSubText> */}
                                    </div>
                                  </AddressFrame>
                              )
                          }
                        </>
                    }
                    {(endPAddrResult.length !== 0 || endAddrResult.length === 0) &&
                        <>
                          {endPAddrResult.map((context) =>
                              <AddressFrame key={context.id} style={{ cursor: "pointer" }} onClick={() => { endPAddresClick(context) }}>
                                <div>
                                  <AddressMainText>{context.place_name}</AddressMainText>
                                  <AddressSubText>{context.road_address_name}</AddressSubText>
                                </div>
                                <div>
                                  <AddressSubText style={{ marginTop: '20px' }}>{context.category_group_name}</AddressSubText>
                                </div>
                              </AddressFrame>
                          )}
                        </>
                    }
                  </PopupWrapper>
                </PricePopup>
              </DialogContent>
              {/* <DaumPostcode
              style={{ height: '100%' }}
              onComplete={handle.EndAddrselectAddress}  // 값을 선택할 경우 실행되는 이벤트
              autoClose={false} // 값을 선택할 경우 사용되는 DOM을 제거하여 자동 닫힘 설정
              defaultQuery='' // 팝업을 열때 기본적으로 입력되는 검색어
            /> */}
            </Dialog>
        }
        <ButtonLine>
          <ButtonBack onClick={() => { navigate('/') }}>이전</ButtonBack>
          <ButtonRed disable={btnDisable} onClick={() => { data.assignType !== 2 ? nextPage() : pickupAndDeliNextPage() }}>다음</ButtonRed>
        </ButtonLine>
      </ContentFrame>
  );
}
const AddressMainText = styled.div`
  font-family: Gongim-Medium;
  font-size: 14px;
  margin-bottom: 5px;
  color: #333;
`;



const AddressSubText = styled.div`
  font-family: Gongim-Reguler;
  font-size: 12px;
  color: #999
`
